export default __webpack_public_path__ + "static/media/terrain.fabdeae6.png";